// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"26b76a52","186":"edfac6e3","331":"3951710a","339":"0e246fa3","362":"8bea4f3d","375":"d7b6a329","442":"4483e21b","446":"366eef66","672":"4c09b3ef","678":"1337daee","778":"9680207d","791":"815a14f4","805":"1374bad2"}[chunkId] + ".chunk.js";
};